document.addEventListener('click', (e)=>{
    let item = e.target;

    if(item.closest('#searchInput') && item.closest('.rebuy-quick-view-dropdown__input-container') && item.closest('.header__search') ){
        let ancestor = item.closest('#rebuy-quick-view-dropdown-search');
        let overlay = ancestor.querySelector('#rebuy-quick-view-overlay');
        overlay.style.display = 'flex';
    }

    if(item.closest('.rebuy-quick-view-dropdown__close') && item.closest('.rebuy-quick-view-dropdown__input-container') && item.closest('.header__search') ){
        let ancestor = item.closest('#rebuy-quick-view-dropdown-search');
        let overlay = ancestor.querySelector('#rebuy-quick-view-overlay');
        overlay.style.display = 'none';
    }
    
    if (!item.closest('.rebuy-quick-view-dropdown__container') && !item.closest('.header__search')) {
        const ancestor = item.closest('#rebuy-quick-view-dropdown-search');
        if (ancestor) {
            const overlay = ancestor.querySelector('#rebuy-quick-view-overlay');
            if (overlay) overlay.style.display = 'none';
        } else {
            // fallback in case user clicks completely outside
            const overlay = document.querySelector('#rebuy-quick-view-overlay');
            if (overlay) overlay.style.display = 'none';
        }
    }

    if(item.closest('.ctm--engrave_btn')){
        // .pplr-wrapper.pplr-checkbox.pplr-customize-your-product
        let i = item.closest('.ctm--engrave_btn');
        let parent_form_el = item.closest('.product-info').querySelector('product-form form');
        let isShow = i.dataset.isShow;

        if(isShow == 'false'){
            let cstmzeEl = parent_form_el.querySelector('.pplr-wrapper.pplr-checkbox.pplr-customize-your-product');
            cstmzeEl.style.display = 'block';
            i.dataset.isShow = 'true';
        }else if(isShow == 'true'){
            let cstmzeEl = parent_form_el.querySelector('.pplr-wrapper.pplr-checkbox.pplr-customize-your-product');
            cstmzeEl.style.display = 'none';
            i.dataset.isShow = 'false';
        }
        
        // Update personalizer container visibility
        updatePersonalizerContainer(parent_form_el);
    }

    if(item.closest('.ctm--gift_btn')){
        // .pplr-wrapper.pplr-checkbox.pplr-customize-your-product
        let i = item.closest('.ctm--gift_btn');
        let parent_form_el = item.closest('.product-info').querySelector('product-form form');
        let isShow = i.dataset.isShow;

        if(isShow == 'false'){
            let giftWrapEl = parent_form_el.querySelector('.pplr-wrapper.pplr-checkbox.pplr-gift-wrapping-1999');
            let giftMsgEl = parent_form_el.querySelector('.pplr-wrapper.pplr-checkbox.pplr-add-gift-message-1399');

            [giftWrapEl, giftMsgEl].forEach(el => el.style.display = "block" );
            i.dataset.isShow = 'true';
        }else if(isShow == 'true'){
            let giftWrapEl = parent_form_el.querySelector('.pplr-wrapper.pplr-checkbox.pplr-gift-wrapping-1999');
            let giftMsgEl = parent_form_el.querySelector('.pplr-wrapper.pplr-checkbox.pplr-add-gift-message-1399');

            [giftWrapEl, giftMsgEl].forEach(el => el.style.display = "none" );
            i.dataset.isShow = 'false';
        }
        
        // Update personalizer container visibility
        updatePersonalizerContainer(parent_form_el);
    }
})

const parent_form_el = document.querySelector('.product-info product-form form');
if (parent_form_el || window.location.pathname.includes('/products/')){
    const observer = new MutationObserver((mutations, obs) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if ( node.nodeType === 1 && (node.matches('.product-personalizer') || node.querySelector('.product-personalizer')) ) {
            const targetEl = document.querySelector('.product-info .ctm--prod_options_buttons');
            if (targetEl) targetEl.removeAttribute('hidden');

            if(node.classList.contains('product-personalizer')){
                let isOtherOptions = node.querySelectorAll('.pplr-customize-your-product');
                if(isOtherOptions.length == 0 && targetEl){ targetEl.querySelector('.ctm--engrave_btn').setAttribute('hidden','') }
            }

            obs.disconnect();
            return;
          }
        }
      }
    });
    observer.observe(parent_form_el, { childList: true, subtree: true });
}


document.addEventListener('rebuy:cart.add', () => { 
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
    let cartDrawer = document.querySelector('cart-drawer'); cartDrawer.open();
});

// Single function to update personalizer container visibility
function updatePersonalizerContainer(parentFormEl) {
    // Get all personalizer elements that can be toggled
    const personalizerElements = [
        parentFormEl.querySelector('.pplr-wrapper.pplr-checkbox.pplr-customize-your-product'),
        parentFormEl.querySelector('.pplr-wrapper.pplr-checkbox.pplr-gift-wrapping-1999'),
        parentFormEl.querySelector('.pplr-wrapper.pplr-checkbox.pplr-add-gift-message-1399')
    ].filter(el => el !== null); // Remove null elements
    
    // Check if all elements are hidden (check both inline and computed styles)
    const allHidden = personalizerElements.every(el => {
        const inlineDisplay = el.style.display;
        const computedDisplay = window.getComputedStyle(el).display;
        return inlineDisplay === 'none' || computedDisplay === 'none';
    });
    
    // Find the product-personalizer container
    const personalizerContainer = parentFormEl.querySelector('.product-personalizer');
    
    if (personalizerContainer) {
        if (allHidden) {
            personalizerContainer.classList.remove('show')
            console.log('Display NONE');
        } else {
            personalizerContainer.classList.add('show')
            console.log('Display Block');
        }
    }
}

function makeShippingProtectionToggleOn(){
    console.log('Event Fired');
    setTimeout(() => {
        let parent = document.querySelector('.simply-insurance .switch-button');
        let i = parent.querySelector('input.cart-insurance-input');
        let label = parent.querySelector('label#switch-label');
        if(i.checked == false){
            label.click();
            console.log('shipping protection toggle clicked');            
        }
    }, 2000);
}

document.addEventListener('on:cart:add', (event) => { 
    let itemCount = event.detail.cart.item_count;
    if(itemCount == 1){ makeShippingProtectionToggleOn() }
})



// free gift handle
window.addToCart = async (id, quantity = 1) => {
    if (document.querySelector('.free_gift_adc_btn')) document.querySelector('.free_gift_adc_btn').disabled = true;
    try {
        const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id, quantity, properties: {__free__gift_product: 'true'} }),
        });

    } catch (err) {
        console.error('Add to cart error:', err);
        return null;
    }
    finally{
        if (window.location.href.includes('/cart')) window.location.reload();
    }
}

window.removeFromCart = async (id) => {
  try {
    const res = await fetch(`/cart/change?id=${id}&quantity=0`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    });
    if (!res.ok) throw new Error(res.status);
    const cartElement = document.querySelector('cart-items');
    cartElement.refresh();
    return;
  } catch (err) {
    console.error('Remove from cart error:', err);
    return null;
  }
}
